export const NoResultIcon = () => (
    <svg width="80px" height="80px" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1334_7391)">
            <rect x="-0.5" width="61" height="61" rx="16" fill="url(#paint0_linear_1334_7391)" />
            <circle cx="48.8867" cy="31.5511" r="13.5" stroke="#414158" strokeWidth="2.5" strokeLinecap="round" />
            <path
                d="M32.86 44.6163L32.225 43.8649C28.1412 38.4077 26.8501 31.0556 29.4442 24.2293C33.4802 13.6093 45.3917 8.28336 56.0494 12.3336C66.7071 16.3838 72.0751 28.2764 68.0391 38.8965C64.2583 48.8454 51.5842 55.2203 38.7985 49.9348"
                stroke="#21212E"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
            <path
                d="M25.5083 49.8298L14.3955 60.8148C12.7874 62.4044 12.8333 65.0151 14.4963 66.5471V66.5471C16.0395 67.9688 18.4235 67.941 19.9332 66.4837L31.989 54.8457C34.9187 52.0176 35.1747 47.4098 32.5764 44.2745V44.2745"
                stroke="#21212E"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
            <path
                d="M24.2031 51.1411L32.6875 42.6997"
                stroke="url(#paint1_linear_1334_7391)"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_1334_7391"
                x1="30"
                y1="25.75"
                x2="30"
                y2="61"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F7F7FA" />
                <stop offset="1" stopColor="#F7F7FA" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1334_7391"
                x1="30.1325"
                y1="43.267"
                x2="25.8048"
                y2="47.6389"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" stopOpacity="0" />
                <stop offset="1" stopColor="#646482" />
            </linearGradient>
            <clipPath id="clip0_1334_7391">
                <rect width="80" height="80" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
